import { Component, OnInit, forwardRef, Optional, Inject, ViewChild, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, NG_ASYNC_VALIDATORS, NgModel } from '@angular/forms';
import { ElementBase } from '../base/element-base';

@Component({
  selector: 'app-textarea',
  templateUrl: './textarea.component.html',
  styleUrls: ['./textarea.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextareaComponent),
      multi: true
    }
  ]
})
export class TextareaComponent extends ElementBase<string> {

  @Input()
  title: string;

  @Input()
  readonly = false;

  @ViewChild(NgModel, {static: true}) model: NgModel;
  @ViewChild('appTextarea', {static: true}) appTextarea;

  constructor(
    @Optional() @Inject(NG_VALIDATORS) validators: Array<any>,
    @Optional() @Inject(NG_ASYNC_VALIDATORS) asyncValidators: Array<any>,
  ) {
    super(validators, asyncValidators);
  }

  onChangeTextArea(): void {
    const textarea = this.appTextarea.nativeElement;
    textarea.style.cssText = 'height:auto;';
    textarea.style.cssText = 'height:' + textarea.scrollHeight + 'px';
  }

}
